import ApiTokenView from 'components/organisms/api-token/ApiTokenView'
import React from 'react'

const ApiToken = () => {
    return (
        <ApiTokenView />
    )
}

export default ApiToken